import React, { Component } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected"; 
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { CATEGORY_COLOR_SET } from '../../../../config/ColorSet';
import { CATEGORY_SET } from '../../../../config/CategorySet'
// import SpinnerBox from '../../spinner-box/SpinnerBox';

class RelationMap extends Component {
  constructor(props){
    super(props);
    // this.state = {
    //   chart: 'hidden',
    //   spinner: true
    // }
  }

  componentDidMount(){  
    let chart = null;
    this.createRelationMap(chart, this.props.data);
  }

  componentWillUnmount(){
    if(this.chart) this.chart.dispose();
  }

  componentDidUpdate(prevProps){
    if((this.props.data != null) && (prevProps.data !== this.props.data)){
      if(this.chart){
        this.chart.dispose();
      }
      let chart = null;
      this.createRelationMap(chart, this.props.data);
    }
  }
  createRelationMap = (chart, dataSet) => {
    chart = am4core.create(this.relationMapChart, am4plugins_forceDirected.ForceDirectedTree)
    am4core.useTheme(am4themes_animated);

    // chart.events.on('ready', ()=>{this.setState({chart:'visible',spinner:false})})
    let series = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())
    
    series.data = dataSet;

    series.data[0]['name'] = "[bold, font-size: 25px]"+series.data[0]['name']+"[/]";

    // Set up data fields
    // series.dataFields.value = 80;

    // series.dataFields.color =am4core.color(CATEGORY_COLOR_SET.etc);

    series.dataFields.value ="value";
    series.dataFields.name = "name";
    series.dataFields.children = "children";

    
    series.data[0].fixed =  true;
    series.data[0].x= am4core.percent(43);
    series.data[0].y= am4core.percent(50);
    series.dataFields.fixed="fixed";
    series.nodes.template.propertyFields.x = "x";
    series.nodes.template.propertyFields.y = "y";
    series.dataFields.color="color";

    // Add labels
    series.nodes.template.label.text = "{name}";
    series.nodes.template.label.fontSize = 13;

    series.nodes.template.label.fill = am4core.color("#000000");
    series.nodes.template.tooltipText = "[bold]{name}[/]"

    //series.fontSize = 10;
    series.minRadius = 30;
    series.maxRadius = 60;
    series.links.template.strokeWidth = 0;
    series.links.template.distance = 1.1;

    let legend = new am4charts.Legend();
    legend.parent = chart.chartContainer;
    legend.background.fillOpacity = 0.05;
    legend.width = 100;
    legend.align = "right";
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.labels.template.text = "[font-size: 13px]{name}[/]";
    let markerTemplate =  legend.markers.template;
    markerTemplate.width = 13;
    markerTemplate.height = 13;
    // legend.data = [{
    //   "name": "문화",
    //   "fill": CATEGORY_COLOR_SET['문화'],
    // },{
    //   "name": "IT",
    //   "fill": CATEGORY_COLOR_SET['IT'],
    // },{
    //   "name": "인물",
    //   "fill": CATEGORY_COLOR_SET['인물'],
    // },{
    //   "name": "경제",
    //   "fill": CATEGORY_COLOR_SET['경제'],
    // },{
    //   "name": "정치사회",
    //   "fill": CATEGORY_COLOR_SET['정치사회'],
    // },{
    //   "name": "심리",
    //   "fill": CATEGORY_COLOR_SET['심리'],
    // },{
    //   "name": "장소",
    //   "fill": CATEGORY_COLOR_SET['장소'],
    // },{
    //   "name": "브랜드",
    //   "fill": CATEGORY_COLOR_SET['브랜드'],
    // },{
    //   "name": "제품",
    //   "fill": CATEGORY_COLOR_SET['제품'],
    // },{
    //   "name": "etc",
    //   "fill": CATEGORY_COLOR_SET['etc'],
    // }]
    CATEGORY_SET.forEach((item)=>{
      legend.data.push({
        "name": item,
        "fill": CATEGORY_COLOR_SET[item]
      })
    })
    

    this.chart = chart;

  }

  render(){
    return(
      // <div>
      //   {this.state.spinner ? <SpinnerBox /> : undefined}
      //   <div id="relation-map" ref={ref=>(this.relationMapChart=ref)} style={{ width: this.props.width, height: this.props.height, visibility:this.state.chart }}></div>
      // </div>
      <div id="relation-map" ref={ref=>(this.relationMapChart=ref)} style={{ width: this.props.width, height: this.props.height }}></div>
    )
  }
}

export default RelationMap;